<template>
  <div>
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick" :style="tabsStyle">
      <el-tab-pane :label="$t('finance', 'accountManagement')" name="first">
        <accountTab v-if="activeName == 'first'" />
      </el-tab-pane>

      <el-tab-pane :label="$t('finance', 'withdrawalList')" name="second">
        <withdrawalTab v-if="activeName == 'second'"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import accountTab from "./components/accountTab.vue";
import withdrawalTab from "./components/withdrawalTab.vue";
import { mapState } from 'vuex';
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "management",
  mixins: [i18nMixin],
  components: {
    accountTab,
    withdrawalTab,
  },
  computed: {
    // 根据当前语言动态计算tab宽度
    tabWidth() {
      const currentLang = this.$store.state.currentLanguage;
      if (currentLang === 'en') {
        return '160px'; // 英文使用160px
      } else {
        return '100px'; // 中文使用100px
      }
    },
    tabsStyle() {
      return {
        '--tab-item-width': this.tabWidth,
        '--tab-active-bar-width': this.tabWidth,
      };
    }
  },
  data() {
    return {
      activeName: "first",
      jurisdiction:false,
    };
  },
  created() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听，添加安全检查
    if (this.$root) {
      this.$root.$off('language-changed');
    }
  },
  // computed: {
  //   ...mapState(['routerArr']),
    
  // },
  // created(){
  //   if(this.$route.query.name){
  //     this.activeName = this.$route.query.name
  //   }
  // },
  // watch:{
  //   routerArr(val){
  //     this.jurisdiction = val.includes("040")
  //     console.log(this.jurisdiction,'this.jurisdiction')
  //   },
  // },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  /deep/ .el-tabs__item  {
    width: var(--tab-item-width) !important;
  }

  /deep/ .el-tabs__active-bar {
   width: var(--tab-active-bar-width) !important;
  }
}
</style>
